import React from 'react';
import useAllCheckins from './useAllCheckins';

const useGetAllCheckins = ({ pageNumber, clinicId }: { pageNumber: number; clinicId?: string }) => {
  const { checkinsData, getAllCheckins, checkinsDataLoading } = useAllCheckins({ pageNumber, clinicId });

  React.useEffect(() => {
    getAllCheckins();
    // eslint-disable-next-line
  }, [pageNumber, clinicId]);

  return {
    checkinsData,
    getAllCheckins,
    checkinsDataLoading,
  };
};

export default useGetAllCheckins;
